module.exports = __webpack_public_path__ + "img/artboard19.51424760.png";